import { GuidT, SelectIF } from '@/types/common';
import { CategoryIF, PropertyBaseIF } from '@/api/propertyApi/types';
import { adaptSeasonFromApi } from '@/helpers/multiSeason';
import { SeasonT } from '@/constants/seasons';

export const transformCategoriesToSelect = (
    backValues?: CategoryIF[],
): SelectIF<GuidT>[] | null => {
    if (!backValues?.length) {
        return null;
    }

    return backValues.map(
        ({ name, guid, parentCategoryGuid, attributes, defaultSeason }) => ({
            label: name,
            value: guid,
            settings: {
                parentId: parentCategoryGuid,
                attributes,
                defaultSeason,
            },
        }),
    );
};

export const transformToSelect = (
    backValues?: PropertyBaseIF[],
): SelectIF<GuidT>[] | null => {
    if (!backValues?.length) {
        return null;
    }

    return backValues.map(({ hex, name, guid, parentCategoryGuid }) => ({
        label: name,
        value: guid,
        settings: {
            hex,
            parentId: parentCategoryGuid,
        },
    }));
};

export const getDefaultSeasons = (
    categories: SelectIF<GuidT>[] | null | undefined,
    categoryGuid: GuidT,
): SeasonT[] => {
    if (!categoryGuid || !categories?.length) {
        return [];
    }

    const category = categories.find((item) => item.value === categoryGuid);

    return adaptSeasonFromApi(category?.settings?.defaultSeason);
};

export const getLabelFromProperties = (
    propertiesData?: SelectIF[] | null,
    searchedValue?: string,
    defaultValue: string = '',
): string => {
    if (!searchedValue || !propertiesData?.length) {
        return defaultValue;
    }

    return (
        propertiesData.find(({ value }) => value === searchedValue)?.label ??
        defaultValue
    );
};
